export default __webpack_public_path__ + "static/media/velozinterior.41ccef54.webp";